import { submitMerge } from '@otto-ec/tracking-bct';

const newsletterUnsubscribeConfirmContentSuccess = document.getElementById("newsletter-unsubscribe-confirm-content-success");
const newsletterUnsubscribeConfirmContentError = document.getElementById("newsletter-unsubscribe-confirm-content-error");

function getEmailFromUrl() {
  try {
    let url_string = window.location.href;
    let url = new URL(url_string);
    let urlEncodedEmailHash = url.searchParams.get("ueeh") !== null ? encodeURIComponent(url.searchParams.get("ueeh")) : null;
    let email = url.searchParams.get("email");
    if (email === null && urlEncodedEmailHash === null) {
      console.log("could not get email or hash from params");
      showNewsletterUnsibscribeConfirmErrorContent();
    } else if (urlEncodedEmailHash !== null) {
      checkEmailHashAndSetPermission(decodeURIComponent(urlEncodedEmailHash))
    }
    else if (email !== null) {
      checkEmailAndSetPermission(email.toLowerCase());
    }
  } catch (err) {
    console.log("could not parse url parameters - " + err);
    showNewsletterUnsibscribeConfirmErrorContent();
  }
}

function showNewsletterUnsibscribeConfirmErrorContent() {
  newsletterUnsubscribeConfirmContentSuccess!.style.display = "none";
  newsletterUnsubscribeConfirmContentError!.style.display = "unset";
}

function showNewsletterUnsibscribeConfirmSuccessContent() {
  newsletterUnsubscribeConfirmContentError!.style.display = "none";
  newsletterUnsubscribeConfirmContentSuccess!.style.display = "unset";
}

function checkEmailAndSetPermission(email: string) {
  const newsletterUnsubscribeEmail = {
    email: email,
  };
  sendUnsubscribeRequest(newsletterUnsubscribeEmail)
}

function checkEmailHashAndSetPermission(emailHash: string) {
  const newsletterUnsubscribeEmailHash = {
    emailHash: emailHash,
  };
  sendUnsubscribeRequest(newsletterUnsubscribeEmailHash)
}

function sendUnsubscribeRequest(newsletterUnsubscribeEmail: any){
  fetch("/newsletter-subscription/unsubscribe", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(newsletterUnsubscribeEmail),
  }).then((res) => {
    if (res.status === 200 && res.status < 500) {
      showNewsletterUnsibscribeConfirmSuccessContent();
      trackMergeSuccess()
    } else {
      showNewsletterUnsibscribeConfirmErrorContent();
      trackMergeFailure()
    }
  });
}

getEmailFromUrl();


function trackMergeSuccess() {
  submitMerge({
    user_Permission: ['Newsletter'],
    user_PermissionActivity: ['false_ok_email'],
  });
}

function trackMergeFailure() {
  submitMerge({
    user_Permission: ['Newsletter'],
    user_PermissionActivity: ['false_error_email'],
  });
}
